export function getRetryDelayFn(delay: number) {
	return (attemptIndex: number) => Math.min(delay * 2 ** attemptIndex, 30000);
}
